goog.provide("shadow.js.shim.module$src$svg$type$adset_channel$video_svg$default");
shadow.js.shim.module$src$svg$type$adset_channel$video_svg$default = shadow.js.shim.module$src$svg$type$adset_channel$video_svg.default;
